export const testimonials = [
  {
    id: 't1',
    quote:
      "Thai IT Solution rebuilt our payments stack in 14 weeks. Uptime went from 97% to 99.98% and our engineering velocity tripled. They feel like an extension of our own team, not a vendor.",
    author: 'Vichai R.',
    role: 'CTO, FinFlow',
    company: 'FinFlow',
    initials: 'VR',
  },
  {
    id: 't2',
    quote:
      "The MedisSphere rollout across 14 hospitals was the smoothest enterprise deployment I've ever seen. Their offline-first sync design alone saved us a seven-figure infrastructure bill.",
    author: 'Dr. Pornthip S.',
    role: 'CIO, MediSphere Health Network',
    company: 'MediSphere',
    initials: 'PS',
  },
  {
    id: 't3',
    quote:
      'We went from a monolith bleeding revenue every Black Friday to a headless platform that handled 12x our previous peak without a hiccup. The team\'s engineering judgment is elite.',
    author: 'Marcus L.',
    role: 'VP Engineering, ShopWave',
    company: 'ShopWave',
    initials: 'ML',
  },
  {
    id: 't4',
    quote:
      'FleetIQ cut our fuel spend by 18% in the first quarter. More importantly, the predictive maintenance alerts have prevented three major fleet incidents. ROI in under six months.',
    author: 'Suchada P.',
    role: 'COO, FleetIQ Logistics',
    company: 'FleetIQ',
    initials: 'SP',
  },
  {
    id: 't5',
    quote:
      'LearnLift isn\'t just software — it changed how 1.2M students learn. The adaptive paths raised completion rates by 37%. Thai IT Solution understood the mission from day one.',
    author: 'Anucha T.',
    role: 'Founder, LearnLift',
    company: 'LearnLift',
    initials: 'AT',
  },
];
